<div class="shares-number-container">
  <div [ngClass]="{'number': hasIssue}">{{ paidAmount | currency: '$': 'code': '1.2-2' }}</div>
  @if (hasIssue) {
    <div class="asic-number">(ASIC) {{ paidAmountAsic | currency: '$': 'code': '1.2-2' }}</div>
  }
</div>
